import { useState } from 'react';
import styles from './styles';
import Carousel from './Carousel';

const UltralabsGallery = ({ block }) => {
  if (!block) return '';

  const { items } = block;
  const uniqueTypes = [...new Set(items?.map(item => item.type))];

  return (
    <>
      <div className='gallery-container'>
        {
          uniqueTypes.map((type, i) => {
            return (
              <Carousel
                key={i}
                items={items}
                type={type}
              />
            )
          })
        }
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default UltralabsGallery;